module.exports = __webpack_public_path__ + "static/img/clause_letter112.5bdc412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_letter112.png
// module id = BcZj
// module chunks = 1